import { Reducer } from "../../lib/redux";
import { TimeZoneInfoActions } from "./actions";
import { TimeZoneInfoActionTypes } from "./types";
import { ITimeZoneInfo } from "../../utils/date";
import { extend } from "../../utils/vanilla";

export let defaultTimeZoneInfo: IIdDictionary<ITimeZoneInfo> = {};

export let timeZoneInfo: Reducer<IIdDictionary<ITimeZoneInfo>, TimeZoneInfoActions> = (state = defaultTimeZoneInfo, action) => {
    switch (action.type) {
        case TimeZoneInfoActionTypes.SET_TIME_ZONE_INFO: {
            const userId = action.payload.userId;
            const timeZoneInfoPayload = action.payload.timeZoneInfo ? extend(true, {}, action.payload.timeZoneInfo) : {} as ITimeZoneInfo;
            if (userId) {
                return {
                    ...state,
                    [userId]: timeZoneInfoPayload
                };
            }
            return {...state};
        }
        case TimeZoneInfoActionTypes.CLEAR_TIME_ZONE_INFO: {
            const userId = action.payload?.userId;
            if (userId) {
                let newState = { ...state };
                delete newState[userId];
                return newState;
            }
            return defaultTimeZoneInfo;
        }
        default:
            return state;
    }
};